import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL, ASSET_URL } from "../../helpers/api";
import { FaPen, FaUserCircle } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function UpdateProfile() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "", // ✅ ADD
    mobile: "",
    address: "",
    sex: "",
    blood_group: "",
    date_of_birth: "",  // ✅ ADD
    picture: "" // ✅ ADD THIS
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [message, setMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  // Fetch profile on mount
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile?token=${token}`);
        if (!res.ok) throw new Error("Failed to fetch profile");

        const data = await res.json();

        setFormData({
          firstname: data.firstname || "",
          lastname: data.lastname || "",
          email: data.email || "",
          mobile: data.mobile || "",
          address: data.address || "",
          sex: data.sex || "",
          blood_group: data.blood_group || "",
          date_of_birth: data.date_of_birth || "", // ✅ ADD
          picture: data.picture || "",
        });
      } catch (err) {
        console.error(err);
        setMessage("Failed to load profile ❌");
      } finally {
        setFetching(false);
      }
    };

    fetchProfile();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Update profile
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    // Required field validation
    if (
      !formData.firstname ||
      !formData.email ||
      !formData.mobile ||
      !formData.address ||
      !formData.sex ||
      !formData.blood_group ||
      !formData.date_of_birth // ✅ ADD
    ) {
      alert("Please fill all required fields marked with *");
      return;
    }

    // Email format validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
        alert("Please enter a valid email address (e.g. example@gmail.com)");
        return;
    }

    // Remove + and check total length
    const digitsOnly = formData.mobile.replace(/\D/g, '');
    if (!formData.mobile.startsWith('+') || digitsOnly.length < 11 || digitsOnly.length > 14) {
        alert("Please enter a valid mobile number with country code followed by exactly 10 digits (e.g. +911234567890)");
        return;
    }

    setLoading(true);

    const formDataToSend = new FormData();

    // append text fields
    Object.keys(formData).forEach((key) => {
      if (key !== "picture") {
        if (key === "password" && !formData[key]) return; // ✅ skip empty password
        formDataToSend.append(key, formData[key]);
      }
    });

    // append image only if selected
    if (selectedImage) {
      formDataToSend.append("picture", selectedImage);
    }

    try {
      const res = await fetch(`${BASE_URL}/user/profile?token=${token}`, {
        method: "POST",
        body: formDataToSend,
      });

      if (!res.ok) throw new Error("Failed to update profile");

      const updatedData = await res.json();
      setSelectedImage(null);

      // ── Update localStorage with fresh data ──
      const fullName = [formData.firstname, formData.lastname]
        .filter(Boolean)
        .join(" ")
        .trim();

      const storage = localStorage.getItem("token") ? localStorage : sessionStorage;
      storage.setItem("userName", fullName);
      storage.setItem("userEmail", formData.email || "");
      storage.setItem("userPhone", formData.mobile || "");

      alert("Profile updated successfully ✅");
      navigate("/patientprofile");
    } catch (err) {
      console.error(err);
      setMessage("Failed to update profile ❌");
    } finally {
      setLoading(false);
    }
  };

  // Delete profile
  const handleDeleteProfile = async () => {
    if (!window.confirm("Are you sure you want to delete your account? ❌"))
      return;

    try {
      const res = await fetch(`${BASE_URL}/user/account?token=${token}`, {
        method: "DELETE",
      });

      if (!res.ok) throw new Error("Failed to delete profile");

      alert("Profile deleted successfully ✅");
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      navigate("/signup");
    } catch (err) {
      console.error(err);
      alert("Failed to delete profile ❌");
    }
  };




    const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // ✅ frontend validation
  if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
    alert("Only JPG, JPEG, PNG allowed");
    return;
  }

  if (file.size > 2 * 1024 * 1024) {
    alert("Max 2MB allowed");
    return;
  }

  // ✅ store file for later upload
  setSelectedImage(file);

  // ✅ preview
  setFormData((prev) => ({
    ...prev,
    picture: URL.createObjectURL(file),
  }));
    };

  if (fetching) return <p>Loading profile...</p>;

  return (
    <form
      onSubmit={handleSubmit}
      className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30"
    >
      <div className="row">


        <div className="col-lg-12 text-center mb-4">

        <div style={{ position: "relative", display: "inline-block" }}>
          
          {formData.picture && formData.picture !== "default.png" ? (
              <img
                  src={
                      formData.picture.startsWith("blob:")
                          ? formData.picture
                          : `${ASSET_URL}/${formData.picture}`
                  }
                  alt="Profile"
                  style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "3px solid #ddd"
                  }}
              />
          ) : (
              <FaUserCircle
                  size={150}
                  color="#b0bec5"
                  style={{
                      border: "3px solid #ddd",
                      borderRadius: "50%"
                  }}
              />
          )}
          {/* ✏️ Pencil Icon */}
          <label
            style={{
              position: "absolute",
              bottom: "5px",
              right: "5px",
              background: "#5aa9e6", // ✅ light blue
              color: "#fff",         // ✅ white pencil
              borderRadius: "50%",
              padding: "6px",
              cursor: "pointer",
              fontSize: "14px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
            }}
          >
            <FaPen size={18} />
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </label>
        </div>

        {/* 👤 Name below image */}
        <div className="cs_input_label cs_heading_color" style={{ marginTop: "10px" }}>
          Profile Picture
        </div>

      </div>

        {/* Firstname */}
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">
            First Name <span className="required-star">*</span>
          </label>
          <input
            type="text"
            name="firstname"
            className="cs_form_field"
            value={formData.firstname}
            onChange={handleChange}
          />
        </div>

        {/* Lastname */}
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Last Name</label>
          <input
            type="text"
            name="lastname"
            className="cs_form_field"
            value={formData.lastname}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div className="col-lg-6 mt-4">
          <label className="cs_input_label cs_heading_color">
            Email <span className="required-star">*</span>
          </label>
          <input
            type="email"
            name="email"
            className="cs_form_field"
            value={formData.email}
            onChange={handleChange}
          />
        </div>


        {/* Password */}
      <div className="col-lg-6 mt-4">
        <label className="cs_input_label cs_heading_color">
          Password
        </label>
        <input
          type="password"
          name="password"
          className="cs_form_field"
          value={formData.password}
          onChange={handleChange}
          placeholder="Leave blank to keep current"
        />
      </div>



        {/* Date of Birth */}
          <div className="col-lg-6 mt-4">
            <label className="cs_input_label cs_heading_color">
              Date of Birth <span className="required-star">*</span>
            </label>
            <DatePicker
              className="cs_form_field"
              selected={formData.date_of_birth ? new Date(formData.date_of_birth) : null}
              onChange={(date) => {
                const formatted = date
                  ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
                  : "";
                setFormData((prev) => ({ ...prev, date_of_birth: formatted }));
              }}
              dateFormat="dd/MM/yyyy"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="Select date of birth"
            />
          </div>

        {/* Phone */}
        <div className="col-lg-6 mt-4">
          <label className="cs_input_label cs_heading_color">
            Mobile <span className="required-star">*</span>
          </label>
          <input
            type="text"
            name="mobile"
            className="cs_form_field"
            value={formData.mobile}
            onChange={handleChange}
          />
        </div>

        {/* Gender */}
        <div className="col-lg-6 mt-4">
          <label className="cs_input_label cs_heading_color">
            Gender <span className="required-star">*</span>
          </label>
          <select
            name="sex"
            className="cs_form_field"
            value={formData.sex}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
          

        {/* Blood Group */}
        <div className="col-lg-6 mt-4">
          <label className="cs_input_label cs_heading_color">
            Blood Group <span className="required-star">*</span>
          </label>
          <select
            name="blood_group"
            className="cs_form_field"
            value={formData.blood_group}
            onChange={handleChange}
          >
            <option value="">Select Blood Group</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="O+">O+</option>
            <option value="O-">O-</option>
          </select>
        </div>

         {/* Address */}
        <div className="col-lg-12 mt-4">
          <label className="cs_input_label cs_heading_color">
            Address <span className="required-star">*</span>
          </label>
          <input
            type="text"
            name="address"
            className="cs_form_field"
            value={formData.address}
            onChange={handleChange}
          />
        </div>

        {/* Buttons */}
        <div className="col-lg-12 mt-4 flex gap-3">
          <button
            type="submit"
            className="cs_btn cs_style_1"
            disabled={loading}
          >
            <span>{loading ? "Updating..." : "Update Profile"}</span>
          </button>
        </div>

        <div className="col-lg-12 mt-4 flex gap-3">
          <button
            type="button"
            className="cs_btn cs_style_1"
            onClick={handleDeleteProfile}
          >
            <span>Delete Profile</span>
          </button>
        </div>

        {message && <p className="mt-3 text-sm">{message}</p>}
      </div>
    </form>
  );
}
